import { createRoot } from "react-dom/client";
import { ContactForm } from "../../islands/ContactForm.js";

const el = document.querySelector<HTMLElement>('[data-island="contact-form"]');
if (el) {
  createRoot(el).render(<ContactForm />);
}
